<template><div><h1 id="haushaltsanreden" tabindex="-1"><a class="header-anchor" href="#haushaltsanreden"><span>Haushaltsanreden</span></a></h1>
<p>Haushaltsanreden — Definiert die Haushaltsanreden</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Steuerung der Haushaltsanreden in der Anschrift und der Briefanrede. Briefanreden werden im System nicht gespeichert, sondern bei der Datenausgabe aufgrund dieser Steuertabelle generiert. Sämtliche mögliche Kombinationen von Sprache, Anzahl Personen im Haushalt, Personen (Erwachsene/Kinder), Geschlecht und Nachname (identisch/verschieden) werden in dieser Tabelle definiert. Durch die Verwendung von Adressbeziehungen können weitere Kombinationen definiert werden. Nebst den Standardanreden können mittels Anredesets die Anreden situationsabhängig gesteuert werden. Z.B. bei einem Spendenaufruf könnte die Briefanrede &quot;Liebe Spender&quot; lauten und bei einem Mitgliedermailing &quot;Liebe Mitglieder&quot; lauten. In der Anrede und Briefanrede können Platzhalter wie Vorname, Nachname, Titel, etc., sowie Steuerzeichen für die Bestimmung der Personen (Erwachsene/Kinder/feminin/masculin) verwendet werden.</p>
<p>Für die Darstellung von Allianz- und Doppelnamen, in der Anrede- und Briefanrede, sind in funtrade spezielle Regeln hinterlegt.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Anreden</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Anrede-Position</dt>
<dd>Darstellung als Baumstruktur mit Anredeset, Sprache und Anredeposition (wird durch funtrade automatisch vergeben).</dd>
<dt>Personenbeziehung</dt>
<dd>Personenbeziehung, Auswahl aus der Tabelle Beziehungen</dd>
<dt>Anzahl Personen bis</dt>
<dd>Anzahl Personen im Haushalt</dd>
<dt>Personen</dt>
<dd>Art der Personen im Haushalt, Erwachsene oder Kinder</dd>
<dt>Geschlecht</dt>
<dd>Geschlecht, feminin oder masculin</dd>
<dt>Nachname</dt>
<dd>Nachname, identisch oder verschieden</dd>
<dt>Anrede</dt>
<dd>Anrede für die Anschrift mit Verwendung von Platzhaltern, siehe Platzhalter</dd>
<dt>Briefanrede</dt>
<dd>Briefanrede mit Verwendung von Platzhaltern, siehe Platzhalter</dd>
<dt>Platzhalter</dt>
<dd>Für die Anrede und Briefanrede können die nachfolgend aufgeführten Platzhalter verwendet werden. Bei den Nachnamen-Platzhaltern, die mit der Zeichenfolge &quot;DNR_&quot; beginnen, erfolgt die Anzeige nach den Regeln für die Darstellung von Allianz- und Doppelnamen (siehe auch <a class="link" href="ft.refdata.anreden.html" title="Einzelanreden">Einzelanreden</a>).
<table>
<thead>
<tr>
<th>Platzhalter</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>&lt;TITEL&gt;</code></td>
<td>Titel aus Adresse</td>
</tr>
<tr>
<td><code v-pre>&lt;ANREDE&gt;</code></td>
<td>Anrede aus Adresse</td>
</tr>
<tr>
<td><code v-pre>&lt;VORNAME&gt;</code></td>
<td>Vorname aus Adresse</td>
</tr>
<tr>
<td><code v-pre>&lt;NACHNAME&gt;</code>,<code v-pre> &lt;DNR_NACHNAME&gt;</code></td>
<td>Nachname aus Adresse</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON&gt;</code></td>
<td>Steuerung, nächste Person</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_FEMININ&gt;</code></td>
<td>Steuerung, nächste Person ist feminin</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_MASCULIN&gt;</code></td>
<td>Steuerung, nächste Person ist masculin</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_ERWACHSEN&gt;</code></td>
<td>Steuerung, nächste Person ist Erwachsen</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_ERWACHSEN_FEMININ&gt;</code></td>
<td>Steuerung, nächste Person ist erwachsen und feminin</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_ERWACHSEN_MASCULIN&gt;</code></td>
<td>Steuerung, nächste Person ist erwachsen und masculin</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_KIND&gt;</code></td>
<td>Steuerung, nächste Person ist Kind</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_KIND_FEMININ&gt;</code></td>
<td>Steuerung, nächste Person ist Kind und feminin</td>
</tr>
<tr>
<td><code v-pre>&lt;PERSON_KIND_MASCULIN&gt;</code></td>
<td>Steuerung, nächste Person ist Kind und masculin</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<p>Die Altersgrenze für die Definition der Kinder kann mit dem Systemparameter &quot;hhaa&quot; definiert werden. Default ist 18.</p>
<h2 id="datenfelder-im-editier-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-im-editier-modus"><span>Datenfelder im Editier-Modus</span></a></h2>
<dl>
<dt>Anredeset</dt>
<dd>Anredeset, Auswahl aus der Tabelle Anredesets</dd>
<dt>Sprache</dt>
<dd>Sprache, Auswahl aus der Tabelle Sprachen</dd>
<dt>Personenbeziehung</dt>
<dd>Personenbeziehung, Auswahl aus der Tabelle Beziehungen</dd>
<dt>Anzahl Personen bis</dt>
<dd>Anzahl Personen im Haushalt</dd>
<dt>Personen</dt>
<dd>Art der Personen im Haushalt, Erwachsene oder Kinder</dd>
<dt>Geschlecht</dt>
<dd>Geschlecht, feminin oder masculin</dd>
<dt>Nachname</dt>
<dd>Nachname, identisch oder verschieden</dd>
<dt>Anrede</dt>
<dd>Anrede für die Anschrift mit Verwendung von Platzhaltern, siehe Platzhalter</dd>
<dt>Briefanrede</dt>
<dd>Briefanrede mit Verwendung von Platzhaltern, siehe Platzhalter</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Druckt die Datensätze als Liste.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.anreden.html" title="Einzelanreden">Einzelanreden</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.tblanredesets.html" title="Anredesets">Anredesets</RouteLink></p>
</div></template>


